export enum PersonNameTypes {
  MAIN_GIVEN_NAME = 'MAINGIVENNAME',
  SOCIAL_GIVEN_NAME = 'SOCIALGIVENNAME',
  GIVEN_NAME = 'DSGIVENNAME',
  MAIN_FAMILY_NAME = 'MAINFAMILYNAME',
  SOCIAL_FAMILY_NAME = 'SOCIALFAMILYNAME',
  FAMILY_NAME = 'DSFAMILYNAME',
  MAIN_COMPONENT_NAME1 = 'MAINCOMPONENTNAME1',
  SOCIAL_COMPONENT_NAME1 = 'SOCIALCOMPONENTNAME1',
  COMPONENT_NAME1 = 'DSCOMPONENTNAME1',
  MAIN_COMPONENT_NAME2 = 'MAINCOMPONENTNAME2',
  SOCIAL_COMPONENT_NAME2 = 'SOCIALCOMPONENTNAME2',
  COMPONENT_NAME2 = 'DSCOMPONENTNAME2',
  MAIN_COMPONENT_NAME3 = 'MAINCOMPONENTNAME3',
  SOCIAL_COMPONENT_NAME3 = 'SOCIALCOMPONENTNAME3',
  COMPONENT_NAME3 = 'DSCOMPONENTNAME3'
}
